import { useMemo } from 'react';
import type { ColumnConfigEntry } from '@erp/shared-types';
import { buildTaskQueueColumns } from './taskQueueCells';

/**
 * Queue columns that keep their identity across renders, rebuilt only when
 * their shape changes. Cells read names, handlers and anchor references from
 * the table's `TaskQueueTableMeta`, so a queue poll re-renders cells in place
 * instead of remounting them.
 */
export function useTaskQueueColumns({
  configuredColumns,
  sortableColumnIds,
  selectable,
  showQuickActions,
}: {
  configuredColumns: ColumnConfigEntry[];
  sortableColumnIds: ReadonlySet<string>;
  selectable: boolean;
  showQuickActions: boolean;
}) {
  // React Compiler skips this hook (it calls no other hooks), so nothing else
  // memoizes the build; without useMemo every render remounts every cell.
  // react-doctor-disable-next-line react-doctor/react-compiler-no-manual-memoization -- the compiler does not compile this hook; useTaskQueueColumns.test.tsx fails without the memo.
  return useMemo(
    () =>
      buildTaskQueueColumns({
        configuredColumns,
        sortableColumnIds,
        selectable,
        showQuickActions,
      }),
    [configuredColumns, sortableColumnIds, selectable, showQuickActions],
  );
}
